import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { rutClean } from 'rut-helpers';
import { ClientRequestService } from '../../../features/services/client-request/client-request.service';
import { DialogMessageComponent } from '../../components/dialog-message/dialog-message.component';
import { soloTieneProductosAFP } from '../../helpers/utils';
import { mandatoSuscritoModal } from '../../models/message.model';
import { DialogService } from '../dialog/dialog.service';
import { LoadingService } from '../loading/loading.service';

export const RUTA_CARTERA_CLIENTES = '/main/client-portfolio';

@Injectable({
  providedIn: 'root',
})
export class MandatoAfpAccesoService {

  private ultimaValidacion: { rut: string; requiereMandato: boolean } = null;

  constructor(
    private clientRequestService: ClientRequestService,
    private dialogService: DialogService,
    private router: Router,
    private loadingService: LoadingService,
  ) {}

  async requiereMandatoAfp(rut: string): Promise<boolean> {
    const reciente = this.leerValidacionReciente(rut);
    if (reciente !== null) return reciente;

    this.loadingService.showLoading(false);
    try {
      const cliente = await this.clientRequestService.consultarCliente({ rut });

      if (!soloTieneProductosAFP(cliente?.DatosProductoGeneral?.DatosProductoBEL)) {
        this.ultimaValidacion = { rut, requiereMandato: false };
        return false;
      }

      const mandato = await this.clientRequestService.consultarMandato({ rut });
      const requiereMandato = mandato?.mandatoSuscrito === false;
      this.ultimaValidacion = { rut, requiereMandato };
      return requiereMandato;
    } catch (error) {
      return false;
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async puedeAcceder(rut: string): Promise<boolean> {
    if (!(await this.requiereMandatoAfp(rut))) return true;
    await this.bloquearAcceso();
    return false;
  }

  async bloquearAcceso(): Promise<void> {
    await this.mostrarModalMandato();
    await this.router.navigate([RUTA_CARTERA_CLIENTES]);
  }

  async mostrarModalMandato(): Promise<void> {
    const dialogRef = this.dialogService.openDialog(DialogMessageComponent, {
      panelClass: 'modal-md',
      disableClose: true,
      data: { optionsMessage: mandatoSuscritoModal },
    });
    await dialogRef.afterClosed().toPromise();
  }

  private leerValidacionReciente(rut: string): boolean | null {
    const validacion = this.ultimaValidacion;
    this.ultimaValidacion = null;
    if (!validacion || rutClean(validacion.rut) !== rutClean(rut)) return null;
    return validacion.requiereMandato;
  }
}
